import React, { Component } from 'react';
import { HashRouter, Route, Switch} from 'react-router-dom';
import StreamPage from './StreamPage';
import AdminPage from './AdminPage/AdminPage';
import EmbedContent from './components/EmbedContent/EmbedContent';
import Modal from './components/Modal/Modal';
import Button from './components/Button/Button';

class App extends Component {

  constructor(props) {
    super();
    this.state = {};

    if (!localStorage.getItem("dirty")) {
      this.state = {
        modal: (
          <Modal title="Welcome!">
            <div className="welcome">
              Welcome to {process.env.REACT_APP_NAME} stream!

              <Button onClick={() => {
                localStorage.setItem("dirty", "1");
                this.setState({modal: null});
              }}>View stream</Button>
            </div>
          </Modal>
        )
      };
    }
  }

  setUpAppSpecificData = () => {
    const darkTheme = process.env.REACT_APP_THEME === "dark";
    
    let primaryColor, secondaryColor, textColor, linkColor;

    if (darkTheme) {
      secondaryColor = process.env.REACT_APP_SECONDARY_COLOR || "#003a00";
      primaryColor = process.env.REACT_APP_PRIMARY_COLOR || "#111";
      textColor = process.env.REACT_APP_TEXT_COLOR || "white";
      linkColor = process.env.REACT_APP_LINK_COLOR || "#079ae2";
    } else {
      secondaryColor = process.env.REACT_APP_SECONDARY_COLOR || "#a06400";
      primaryColor = process.env.REACT_APP_PRIMARY_COLOR || "#fff1dd";
      textColor = process.env.REACT_APP_TEXT_COLOR || "#333";
      linkColor = process.env.REACT_APP_LINK_COLOR || "blue";
    }

    const styles = `
      body {
        background-color: ${primaryColor};
        color: ${textColor};
      }

      .primary-color {
        color: ${primaryColor};
      }

      .primary-background {
        background-color: ${primaryColor};
      }

      .primary-border {
        border-color: ${primaryColor};
      }

      .secondary-color {
        color: ${secondaryColor};
      }

      .secondary-background {
        background-color: ${secondaryColor};
      }

      .secondary-border {
        border-color: ${secondaryColor};
      }

      a {
        color: ${linkColor};
      }
    `;

    const styleSheet = document.createElement("style")
    styleSheet.type = "text/css"
    styleSheet.innerText = styles
    document.head.appendChild(styleSheet);

    document.title = process.env.REACT_APP_NAME;
  }

  render() {


    this.setUpAppSpecificData();

    return (
      <div className="root-element">
        
        {
          this.state.modal
          ?
          this.state.modal
          :
          (
            <HashRouter>
              <Switch>
                <Route path="/admin">
                  <AdminPage />
                </Route>
                <Route path="/embed">
                  <EmbedContent />
                </Route>
                <Route path="/">
                  <StreamPage />
                </Route>
              </Switch>
            </HashRouter>
          )
        }

      </div>
    );
  }
}

export default App;
